var base = require('settings/teams/encircle-token');

Vue.component('spark-encircle-token', {
    mixins: [base]
});
